module.exports = __webpack_public_path__ + "images/stop34ecc057fbc9242a10a7186bc1b210a2.svg";